/* istanbul ignore file */
export const FlashIcon = () => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="3" y="3" width="40" height="40" rx="20" fill="#F2F4F7" />
            <rect
                x="3"
                y="3"
                width="40"
                height="40"
                rx="20"
                stroke="#F9FAFB"
                strokeWidth="6"
            />
            <path
                d="M23.8333 14.6665L15.5 24.6665H23L22.1667 31.3332L30.5 21.3332H23L23.8333 14.6665Z"
                stroke="#606060"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
